import { Chip, Paper, Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from "@mui/material";
import CopyableMono from "./CopyableMono";
import { formatAmount, formatUnixSeconds } from "../../../../../utils/aeropayFormat";
 
export default function AeropayTxTable({
  rows,
  hasNext,
  page,
  rowsPerPage,
  paginationCount,
  onChangePage,
  onChangeRowsPerPage,
}) {
  return (
    <Paper elevation={2}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>User ID</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Fee</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Created Date</TableCell>
            <TableCell>UUID</TableCell>
            <TableCell>Merchant Reputation Status</TableCell>
            <TableCell>Merchant Name</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((tx) => (
            <TableRow key={tx.uuid}>
              <TableCell>{tx.id}</TableCell>

              <TableCell>
                <Chip
                  label={tx.status}
                  size="small"
                  color={tx.status === "completed" ? "success" : tx.status === "pending" ? "warning" : "default"}
                />
              </TableCell>

              <TableCell>{tx.title}</TableCell>
              <TableCell>{tx.userId}</TableCell>
              <TableCell>{formatAmount(tx.amount)}</TableCell>
              <TableCell>{formatAmount(tx.apFee)}</TableCell>
              <TableCell>{tx.paymentType ?? "-"}</TableCell>
              <TableCell>{formatUnixSeconds(tx.createdDate)}</TableCell>
              <TableCell>
                <CopyableMono value={tx.uuid} />
              </TableCell>
              <TableCell>{tx.merchantReputationStatus ?? "-"}</TableCell>
              <TableCell>{tx.merchantName ?? "-"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <TablePagination
        component="div"
        count={paginationCount}
        page={page}
        onPageChange={onChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onChangeRowsPerPage}
        rowsPerPageOptions={[10, 25, 50, 100]}
        nextIconButtonProps={{ disabled: !hasNext }}
        backIconButtonProps={{ disabled: page === 0 }}
        labelDisplayedRows={({ from, to }) => `${from}-${to}`}
      />
    </Paper>
  );
}
